const firstYouTubeVideoContainer = document.querySelector('[data-video-content-type]');
const firstInstagramMediaContainer = document.querySelector('[data-instagram-content]');
const firstTikTokMediaContainer = document.querySelector('[data-tiktok-content]');

const optionsObservers = {
    root: null,
    rootMargin: '200px 0px',
    threshold: 0.25,
};

/**
 * Asynchronously imports a module for handling TikTok media and
 * dispatches a custom event with the imported module as a detail.
 */
const loadTikTokResources = async function () {
    const module = await import('./tiktokMediaHandler');
    const contentMediaSubject$ = module.default;

    const event = new CustomEvent('tiktokMediaHandlerDownloaded', { 
        detail: {
            contentMediaSubjectObserver: contentMediaSubject$
        }
    });

    document.body.dispatchEvent(event);
}

/**
 * An Intersection Observer callback that loads TikTok
 * resources when the observed element is intersecting with the viewport.
 * @param entries - The `entries` parameter in the `callBackTikTokObserver` function is an array of
 * `IntersectionObserverEntry` objects. These objects represent the changes to the intersection between
 * the target element being observed and the root element or viewport.
 * @param observer - The `observer` parameter in the `callBackTikTokObserver` function is an instance
 * of the `IntersectionObserver` class. It is used to observe changes in the intersection of a target
 * element with a specified root element or viewport. The observer is responsible for triggering the
 * callback function.
 */
const callBackTikTokObserver = (entries, observer) => {
    entries.forEach(async entry => {
        if (entry.intersectionRatio > 0 && entry.isIntersecting) {
            await loadTikTokResources();
            observer.disconnect();
        }
    });
};

/* Checking if the variable
`firstTikTokMediaContainer` is truthy (i.e., it exists and is not null or undefined). If
`firstTikTokMediaContainer` is truthy, it creates a new `IntersectionObserver` named
`tiktokMediaObserver` that will observe the element referenced by `firstTikTokMediaContainer`
using the options defined in `optionsObservers`. */
if(firstTikTokMediaContainer) {
    const tiktokMediaObserver = new IntersectionObserver(callBackTikTokObserver, optionsObservers);
    tiktokMediaObserver.observe(firstTikTokMediaContainer);
}

/**
 * The function `loadInstagramResources` asynchronously loads an Instagram media handler module and
 * dispatches a custom event with the loaded content media subject observer.
 */
const loadInstagramResources = async function () {
    const module = await import('./instagramMediaHandler');
    const contentMediaSubject$ = module.default;

    const event = new CustomEvent('instagramMediaHandlerDownloaded', { 
        detail: {
            contentMediaSubjectObserver: contentMediaSubject$
        }
    });

    document.body.dispatchEvent(event);
}

/**
 * Used to observe when an element becomes visible on the
 * page and then loads Instagram resources.
 * @param entries - The `entries` parameter in the `callBackInstagramObserver` function is an array of
 * IntersectionObserverEntry objects. These objects represent the changes to the intersection between a
 * target element and its root container that the observer is monitoring.
 * @param observer - The `observer` parameter in the `callBackInstagramObserver` function is an
 * instance of the `IntersectionObserver` class. It is used to observe changes in the intersection of a
 * target element with a specified root element or viewport. The observer is responsible for triggering
 * the callback function.
 */
const callBackInstagramObserver = (entries, observer) => {
    entries.forEach(async entry => {
        if (entry.intersectionRatio > 0 && entry.isIntersecting) {
            await loadInstagramResources();
            observer.disconnect();
        }
    });
};

/* This observer will monitor changes in the intersection of the observed element with a 
specified root element or viewport. When the observed element becomes visible on the page,
the `callBackInstagramObserver` function will be triggered to load Instagram resources asynchronously. */
if(firstInstagramMediaContainer) {
    const instagramMediaObserver = new IntersectionObserver(callBackInstagramObserver, optionsObservers);
    instagramMediaObserver.observe(firstInstagramMediaContainer);
}

/**
 * fetchDependentModules: Function in charge of fetch YouTube handler on async way.
 */
const loadYouTubeResources = async function(){
    const module = await import('./youtubeHandler');
    const videosSubject$ = module.default;

    const event = new CustomEvent('youtubeHandlerDownloaded', {
        detail: {
            videosSubjectObserver: videosSubject$
        }
    });

    document.body.dispatchEvent(event);
}

/**
 * callBackObserver: Function in charge of evaluate if the video is visible.
 */
const callBackYoutubeVideoObserver = (entries, observer) => {
    entries.forEach(async entry => {
        if (entry.intersectionRatio > 0 && entry.isIntersecting) {
            await loadYouTubeResources();
            observer.disconnect();
        }
    });
};

/* That will observe the element referenced by
`firstYouTubeVideoContainer` using the options defined in `optionsObservers`. */
if(firstYouTubeVideoContainer){
    const youtubeVideoObserver = new IntersectionObserver(callBackYoutubeVideoObserver, optionsObservers);
    youtubeVideoObserver.observe(firstYouTubeVideoContainer);
}
